import React, { Component } from 'react';
import { Layout } from 'antd';
import LeftMenu from '../controls/LeftMenu'

class LeftPane extends Component {
    state = {
        collapsed: false,
      };
    
      onCollapse = (collapsed) => {
        this.setState({ collapsed });
      }
  
    render() {
      return (
        <Layout.Sider theme="light" collapsible
            width = {250}
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse} style={{ padding: 0, "textAlign":"left" }} breakpoint="lg" collapsedWidth="25" >
                <LeftMenu/>
        </Layout.Sider>   
   );
  }
}

export default LeftPane;